import { useState } from "react";

export default function FloatingEdgeCTA({
                                          tabText = "Explore All Packages & Prices",
                                          title = "Pooja Packages",
                                          description = "Book your personalized pooja experience online with ease.",
                                          ctaText = "View All Packages",
                                          ctaUrl = "https://bookmypoojaonline.com/",
                                          features = [
                                            { label: "Expert", icon: "users" },
                                            { label: "Quick", icon: "calendar" },
                                            { label: "Trusted", icon: "badge" }
                                          ],
                                          delayMs = 1500
                                        }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const getIcon = (iconName) => {
    const icons = {
      users: (
        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
      ),
      calendar: (
        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"/>
      ),
      badge: (
        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
      ),
      star: (
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
      ),
      check: (
        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
      )
    };
    return icons[iconName] || icons.badge;
  };

  return (
    <>
      {/* Backdrop */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={() => setIsExpanded(false)}
        />
      )}

      <div
        className="fixed top-1/2 right-0 z-50"
        style={{
          animation: `slideInFromRight 0.7s ease-out ${delayMs}ms both`,
        }}
      >
        {/* Vertical Tab Button */}
        {!isExpanded && (
          <button
            onClick={() => setIsExpanded(true)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="
              group relative block
              bg-gradient-to-br from-BluntRed via-orange-600 to-red-600
              text-white font-bold
              px-3 py-6
              rounded-l-2xl
              shadow-2xl
              overflow-hidden
              transition-all duration-500 ease-out
              hover:shadow-2xl
              cursor-pointer
              writing-mode-vertical
            "
            style={{
              boxShadow: '0 10px 40px rgba(249, 115, 22, 0.4), 0 0 20px rgba(239, 68, 68, 0.3)',
              writingMode: 'vertical-rl',
            }}
          >
            {/* Animated background gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-orange-400/0 via-white/20 to-orange-400/0
                            translate-y-[-100%] group-hover:translate-y-[100%]
                            transition-transform duration-1000 ease-in-out" />

            {/* Sparkle effect */}
            <div className="absolute top-1 right-1 w-2 h-2 bg-white rounded-full
                            opacity-0 group-hover:opacity-100
                            animate-ping" />

            {/* Content */}
            <div className="relative flex items-center gap-2">
              <span className="text-sm whitespace-nowrap">
                {tabText}
              </span>
              <span className={`
                transform transition-all duration-300
                ${isHovered ? 'scale-110' : 'scale-100'}
              `}>
                ✨
              </span>
            </div>

            {/* Floating particles */}
            <div className="absolute top-1 right-1 w-2 h-2 bg-yellow-300 rounded-full
                            animate-bounce opacity-70"
                 style={{ animationDelay: '0s', animationDuration: '2s' }} />
            <div className="absolute bottom-1 right-1 w-2 h-2 bg-orange-300 rounded-full
                            animate-bounce opacity-60"
                 style={{ animationDelay: '0.5s', animationDuration: '2.5s' }} />
          </button>
        )}

        {/* Compact Expanded Panel */}
        {isExpanded && (
          <div
            className={`
              bg-white rounded-l-2xl shadow-2xl
              p-4 w-64
              transition-all duration-500 ease-out
              ${isExpanded ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
            `}
            style={{
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3), 0 0 40px rgba(249, 115, 22, 0.2)',
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsExpanded(false)}
              className="
                absolute top-3 right-3
                w-7 h-7
                flex items-center justify-center
                bg-gray-100 hover:bg-gray-200
                rounded-full
                transition-all duration-200
                group/close
              "
            >
              <svg
                className="w-4 h-4 text-gray-600 group-hover/close:text-gray-800 transition-colors"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Content */}
            <div className="mt-1">
              <div className="flex items-center gap-2 mb-3">
                <h3 className="text-lg font-bold bg-gradient-to-r from-BluntRed to-red-600 bg-clip-text text-transparent">
                  {title}
                </h3>
              </div>

              <p className="text-gray-600 text-xs mb-4 leading-relaxed">
                {description}
              </p>

              {/* CTA Button */}
              <a
                href={ctaUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  block w-full
                  bg-gradient-to-br from-BluntRed via-orange-600 to-red-600
                  text-white font-semibold
                  px-4 py-2.5
                  rounded-xl
                  text-center text-sm
                  shadow-lg
                  hover:shadow-xl
                  transform hover:scale-105
                  transition-all duration-300
                  relative overflow-hidden
                  group
                "
              >
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0
                                translate-x-[-100%] group-hover:translate-x-[100%]
                                transition-transform duration-700" />
                <span className="relative flex items-center justify-center gap-2">
                  {ctaText}
                  <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                </span>
              </a>

              {/* Features */}
              {features && features.length > 0 && (
                <div className="mt-4 flex items-center justify-center gap-4 text-BluntRed">
                  {features.map((feature, idx) => (
                    <div key={idx} className="flex flex-col items-center gap-1">
                      <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          {getIcon(feature.icon)}
                        </svg>
                      </div>
                      <span className="text-xs font-medium">{feature.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}